/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';
import {state} from '@/store/modules/user-session';
import pkce from '@/services/pkce';

/**
 * oAuth authentication route guard.
 *
 * In order to process oAuth authorisation we need to have an oAuth code.
 *
 * @param to
 * @param from
 * @param next
 */
export const oAuthGuard: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    // code should exist and be a UUID
    if (!to.query.code || !(to.query.code as string).match(/^[a-f0-9]{8}[-]([a-f0-9]{4}[-]){3}[a-f0-9]{12}$/i)) {
        next('/');
        return;
    }

    // check that the state is a match for the hash of the verifier
    if (!to.query.state || (to.query.state !== pkce.createState(state.session.verifier))) {
        next('/');
        return;
    }

    next();
};
